// Generated by Melange

import * as Buhta_cabinet__Route from "../../Route.js";
import * as Caml_option from "melange.js/caml_option.js";
import * as Cn from "../../../../../vendored/classnames/Cn.js";
import * as Curry from "melange.js/curry.js";
import * as ReasonReactRouter from "reason-react/ReasonReactRouter.js";
import * as JsxRuntime from "react/jsx-runtime";

function handleClick(ev, to_) {
  const metaClick = ev.metaKey || ev.ctrlKey || ev.altKey || ev.shiftKey;
  if (!metaClick) {
    ev.preventDefault();
    ev.stopPropagation();
    return ReasonReactRouter.push(to_);
  }
  
}

function make(route) {
  return function (classNameOpt) {
    const className = classNameOpt !== undefined ? classNameOpt : "";
    return function (tabIndex) {
      return function (onLinkClickedOpt) {
        const onLinkClicked = onLinkClickedOpt !== undefined ? onLinkClickedOpt : (function (param) {
              
            });
        return function (children) {
          return function (disabledOpt) {
            const disabled = disabledOpt !== undefined ? disabledOpt : false;
            return function (urlParamsOpt) {
              const urlParams = urlParamsOpt !== undefined ? urlParamsOpt : /* [] */0;
              return function (targetOpt) {
                const target = targetOpt !== undefined ? targetOpt : "_self";
                return function (onMouseEnterOpt) {
                  const onMouseEnter = onMouseEnterOpt !== undefined ? onMouseEnterOpt : (function (param) {
                        
                      });
                  return function (onMouseLeaveOpt) {
                    const onMouseLeave = onMouseLeaveOpt !== undefined ? onMouseLeaveOpt : (function (param) {
                          
                        });
                    const href = Buhta_cabinet__Route.urlWithParams(Buhta_cabinet__Route.toString(route), urlParams);
                    const onClick = function (ev) {
                      if (disabled) {
                        return ;
                      } else {
                        handleClick(ev, href);
                        window.scrollTo(0, 0);
                        return Curry._1(onLinkClicked, undefined);
                      }
                    };
                    let tmp = {
                      children: children,
                      className: Cn.$plus("cursor-pointer", className),
                      disabled: disabled,
                      href: href,
                      target: target,
                      onClick: onClick,
                      onMouseEnter: onMouseEnter,
                      onMouseLeave: onMouseLeave
                    };
                    if (tabIndex !== undefined) {
                      tmp.tabIndex = Caml_option.valFromOption(tabIndex);
                    }
                    return JsxRuntime.jsx("a", tmp);
                  };
                };
              };
            };
          };
        };
      };
    };
  };
}

function Link(Props) {
  return Curry._8(make(Props.route)(Props.className), Props.tabIndex, Props.onLinkClicked, Props.children, Props.disabled, Props.urlParams, Props.target, Props.onMouseEnter, Props.onMouseLeave);
}

const make$1 = Link;

export {
  handleClick ,
  make$1 as make,
}
/* Buhta_cabinet__Route Not a pure module */
